import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { ChangeDetectorRef, ComponentRef, Injectable } from '@angular/core';
import { LocationDetailFormValue } from 'src/app/pages/location-details/models/location-detail-form';
import { BaseInfoService } from '../../account-wizard-helpers/services/base-info.service';
import { AccountLocationView } from '../../add-account-location/models/account-location-view.model';
import { LocationInfoComponent } from '../location-summary/location-info.component';

@Injectable()
export class LocationInfoService extends BaseInfoService<LocationInfoComponent> {
   constructor(overlay: Overlay) {
      super(overlay, LocationInfoComponent, 'location-info-panel');
   }

   protected updateComponentData(
      componentRef: ComponentRef<LocationInfoComponent>,
      data: LocationDetailFormValue
   ): void {
      componentRef.instance.location = data;
   }

   showLocationInfo(
      locationViewModel: AccountLocationView,
      button: HTMLElement,
      changeDetectorRef?: ChangeDetectorRef
   ) {
      const connectedPositions: ConnectedPosition[] = [
         {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
         },
         {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
         },
      ];

      const outsidePointerEventsCallback = () => {
         this.selectedId = null;
         changeDetectorRef?.markForCheck();
         this.outsidePointerEvent$.next();
      };

      this.openOverlay(locationViewModel, button, connectedPositions, outsidePointerEventsCallback.bind(this));

      if (this.selectedId === locationViewModel.houseNumber) {
         this.selectedId = null;
      } else {
         this.selectedId = locationViewModel.houseNumber ?? null;
      }
   }
}
